const PROTOCOLODOCUMENTO = () => import('./main.vue');

const moduleRoutes = import.meta.glob('./*/routes.js', { eager: true });

export default [
  {
    name: 'relatorio/protocolo-documento',
    path: '/relatorio/protocolo-documento',
    component: PROTOCOLODOCUMENTO,
    meta: {
      requiresAuth: true,
      breadcrum: 'Documento',
      icon: 'folder-open',
      can: 'list',
      on: 'relatorioprotocolodocumento',
      bisneto: true,
    },
    children: [...Object.values(moduleRoutes).flatMap((module) => module.default)],
  },
];
